import { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Navigation } from "./components/navigation";
// import { Header } from "./components/header";
// import { About } from "./components/about";
// import { Services } from "./components/services";
import { Contact } from "./components/contact";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";
// import { Testimonials } from "./components/testimonials";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <div>
        <Navigation />
        <Switch>
          <Route exact path="/">
            {/* <Header data={landingPageData.Header} /> */}
            {/* <Features data={landingPageData.Features} /> */}
            {/* <About data={landingPageData.About} /> */}
            {/* <Services data={landingPageData.Services} /> */}
            {/* <Gallery data={landingPageData.Gallery}/> */}
            {/* <Testimonials data={landingPageData.Testimonials} /> */}
            {/* <Team data={landingPageData.Team} /> */}
            <Contact data={landingPageData.Contact} />
          </Route>
          <Route path="/privacy-policy">
            <PrivacyPolicy />
          </Route>
          <Route path="/terms-and-conditions">
            <TermsAndConditions />
          </Route>
        </Switch>
      </div>
    </Router>
  );
};

export default App;
